import { ArrowLeft, ArrowRight, CalendarCheck, Loader2 } from "lucide-react";

const primary = "inline-flex items-center gap-2 rounded-full bg-argia-red px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-argia-redDark disabled:opacity-40";

export const BookingNav = ({ step, canNext, submitting, onBack, onNext, onSubmit }) => (
  <div className="mx-auto mt-10 flex max-w-2xl items-center justify-between">
    <button
      data-testid="booking-back"
      onClick={onBack}
      disabled={step === 0}
      className="inline-flex items-center gap-2 rounded-full border border-argia-ink px-6 py-3 text-sm font-semibold text-argia-ink transition-all duration-300 hover:bg-argia-ink hover:text-white disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-argia-ink"
    >
      <ArrowLeft size={16} strokeWidth={1.5} /> Retour
    </button>
    {step < 3 ? (
      <button data-testid="booking-next" onClick={onNext} disabled={!canNext} className={primary}>
        Continuer <ArrowRight size={16} strokeWidth={1.5} />
      </button>
    ) : (
      <button data-testid="booking-submit" onClick={onSubmit} disabled={submitting} className={primary}>
        {submitting ? <Loader2 size={16} className="animate-spin" /> : <CalendarCheck size={16} strokeWidth={1.5} />}
        Confirmer le rendez-vous
      </button>
    )}
  </div>
);
